import { NgModule } from '@angular/core';
import { ModalsDirectivesModule } from './directives/modals-directives.module';
import { MonModalService } from './services/mon-modal/mon-modal.service';

@NgModule({
    imports: [
        ModalsDirectivesModule,
    ],
    providers: [
        MonModalService,
    ],
})
export class ModalsModule {}
